/**
 * Terms of service text for the informational modal (just viewing terms)
 * This is the text that should be displayed to inform users about payment method storage
 */
export const PAYMENT_METHOD_ON_FILE_INFO_TERMS_TEXT =
  'By saving payment details for future purchases, merchant hereby confirms that it has requested and received explicit cardholder consent to store card and cardholder information in this system.'

/**
 * Additional terms and conditions for payment method on file
 * This is the liability disclaimer text shown in the expandable section
 */
export const PAYMENT_METHOD_ON_FILE_ADDITIONAL_TERMS_TEXT =
  'Lightspeed will not be liable to merchant or cardholder for any loss whatsoever including but not limited to losses related to (i) card and cardholder information stored without cardholder consent (ii) any charges made to this card by merchant with or without customer authorization (iii) insufficient card or cardholder verifications by merchant.'
